/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_TitleInputs */

const en_common_error_title = /** @type {(inputs: Common_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oops`)
};

const zh_common_error_title = /** @type {(inputs: Common_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出错了`)
};

/**
* | output |
* | --- |
* | "Oops" |
*
* @param {Common_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_error_title = /** @type {((inputs?: Common_Error_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_error_title(inputs)
	return zh_common_error_title(inputs)
});
export { common_error_title as "common.error.title" }